




























































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
@Component({
  $_veeValidate: { validator: 'new' },
})

export default class AgrMascota extends Vue {


  private menu = false;
  private menu1 = false;
  private razas: any = [];
  private fechaVac = new Date().toISOString().substr(0, 10);
  private toggleExclusive = undefined;

  // Variables
  private etiquetasSlider = ['CH', 'M', 'G', 'EG'];
  private data = { raza: '', tamano: '', tipo: ''};
  private formulario = { 
    idCliente: '',
    idMascota: '',
    petName: '', 
    idRaza: '', 
    fechaNac: '', 
    sexo: '',
    castrado: '', 
    ultVacuna: '', 
    ultVacunaExp: '', 
    autPersona: '',
    autPersTel: '',
    Peso : '',
    Color : '',
    SenaParticular : '',
    idGroomerPref : '',
    pielNormal : '',
    pielLlagas : '',
    perdidaPelo : '',
    pielSeca : '',
    pielPulgasGarr : '',
    artritis : '',
    ceguera : '',
    epilepsia : '',
    sordera : '',
    alergia1: '', 
    alergia2: '', 
    nomVeterinario : '',
    telVeterinario : '',
    fallecida : '',
    fechaFallecida : '',
    urlMascota: '',
    urlVacBorde: '', 
    urlVacRabia: '', 
    urlVacMulti: ''
  };
  private nombre = '';
  private cumpleanios = new Date().toISOString().substr(0, 10);
  private tamMascota: any = '';
  private tipoMasc = '';
  private esterilizada: any = '';
  private sexo = '';
  private personaAut = '';
  private visible = 'd-none';
  private razaSeleccionada: any = [];
  private date = new Date().toJSON();
  private reglas: any = [(v: any) => !! v || 'Este campo es requerido'];
  private valid = true;
  private vacuna = new Date().toISOString().substr(0, 10);
  private terminos = '';
  private peso = '';
  private disableTam = true;
  private cartilla: any = [];
  private urlMascota: any = [];
  private alimentos: any = [];
  private alimentoSelected: any = {TEXTO: ''};
  /*Imágenes*/
  private img_dog = 'dog.png';
  private img_cat = 'cat.png';
  /*SnackBar*/
  private snackbar = false;
  private text = '';
  private timeout = 2000;
  private type = '';
  /*Modals*/
  private terms = false;
  private infoTam = false;
  /* Imagen */
  private nombreFoto = '';
  private nombreFotoR = '';
  private nombreFotoM = '';
  private nombreFotoB = '';
  private urlFoto = ''; // Foto mascota
  private urlFotoR = '' // Foto rabia
  private urlFotoM = '' // Foto múltiple
  private urlFotoB = '' // Foto bordetella


  /* Methods*/
  private pickFile(value: any) {
    // @ts-ignore
    value === 1 ? this.$refs.image.click(): 
    // @ts-ignore
    value === 2 ? this.$refs.imageR.click():
    // @ts-ignore
    value === 3 ? this.$refs.imageM.click(): 
    // @ts-ignore
    value === 4 ? this.$refs.imageB.click():
    // @ts-ignore            
    this.$refs.imageR.click();
  }

  // Carga de fotos para la mascota y la cartilla
  private onMascotaImage(e: any) {
    let imageFile: any = [];
    const files = e.target.files
    if(files[0] !== undefined && files[0].size !== 'undefined') {
      imageFile = files[0] // Imagen válida y lista para subirse
      this.nombreFoto = imageFile.name;
      const extension = imageFile.name.substring(imageFile.name.length - 4, imageFile.name.length);
      imageFile.newName = this.$store.getters.user + this.nombre + extension;
      this.$store.dispatch('uploadImage', [imageFile])
      .then((valor: any) => {
        const DEV_URL = 'http://localhost';
        const PROD_URL = 'https://citas.petco.com.mx';
        // Si es exitosa, se manda a llamar a la imagen cargada, guardarla en url1
        const link = PROD_URL;
        //this.urlFoto = link + '/' + valor[0] + '?date=' + new Date();
        this.urlFoto = link + '/' + valor[0]; // Foto subida
      });
    } else {
      imageFile = [];
      this.urlFoto = '';
    }
  }
  
  private onMascotaurlVacRabia(e: any) {
    const files = e.target.files
    if(files[0] !== undefined && files[0].size !== 'undefined') {
    let imageFile = files[0];
    // Colocamos nuevo nombre a cada una de las fotografías
    this.nombreFotoR = imageFile.name;
    let extension = imageFile.name.substring(imageFile.name.length - 4, imageFile.name.length);
    imageFile.newName = this.$store.getters.user +'-'+new Date().toISOString().slice(0,10).split('-').join('')+ this.nombre + "-RABIA." + extension;
    
    this.$store.dispatch('uploadImage', [imageFile])
    .then((valor: any) => {
      const DEV_URL = 'http://localhost';
      const PROD_URL = 'https://citas.petco.com.mx';
      // Si es exitosa, se manda a llamar a la imagen cargada, guardarla en url1
      const link = PROD_URL;
      //this.urlFoto = link + '/' + valor[0] + '?date=' + new Date();
      this.urlFotoR = link + '/' + valor[0];
    });
    } else {
      this.urlFotoR = '';
    }
  }
  private onMascotaurlVacMulti(e: any) {
    const files = e.target.files
    if(files[0] !== undefined && files[0].size !== 'undefined') {
    let imageFile = files[0];
    // Colocamos nuevo nombre a cada una de las fotografías
    this.nombreFotoM = imageFile.name;
    let extension = imageFile.name.substring(imageFile.name.length - 4, imageFile.name.length);
    imageFile.newName = this.$store.getters.user +'-'+new Date().toISOString().slice(0,10).split('-').join('')+ this.nombre + "-MULTIPLE." + extension;
    
    this.$store.dispatch('uploadImage', [imageFile])
    .then((valor: any) => {
      const DEV_URL = 'http://localhost';
      const PROD_URL = 'https://citas.petco.com.mx';
      // Si es exitosa, se manda a llamar a la imagen cargada, guardarla en url1
      const link = PROD_URL;
      //this.urlFoto = link + '/' + valor[0] + '?date=' + new Date();
      this.urlFotoM = link + '/' + valor[0];
    });
    } else {
      this.urlFotoM = '';
    }
  }
  private onMascotaurlVacBorde(e: any) {
    const files = e.target.files
    if(files[0] !== undefined && files[0].size !== 'undefined') {
    let imageFile = files[0];
    // Colocamos nuevo nombre a cada una de las fotografías
    this.nombreFotoB = imageFile.name;
    let extension = imageFile.name.substring(imageFile.name.length - 4, imageFile.name.length);
    imageFile.newName = this.$store.getters.user +'-'+new Date().toISOString().slice(0,10).split('-').join('')+ this.nombre + "-BORDETELLA." + extension;
    
    this.$store.dispatch('uploadImage', [imageFile])
    .then((valor: any) => {
      const DEV_URL = 'http://localhost';
      const PROD_URL = 'https://citas.petco.com.mx';
      // Si es exitosa, se manda a llamar a la imagen cargada, guardarla en url1
      const link = PROD_URL;
      //this.urlFoto = link + '/' + valor[0] + '?date=' + new Date();
      this.urlFotoB = link + '/' + valor[0];
    });
    } else {
      this.urlFotoB = '';
    }
  }

  private showInfoTamanio(){
    this.infoTam = true;
  }

  @Watch('razaSeleccionada')
  private onChangeMasc(newm : any ) {
    if (newm.IDRAZA === '00203') {
      this.disableTam = false;
      this.tamMascota = 0;
    } else if (newm.TAMANO === "S") {
      this.tamMascota = 0;
      this.disableTam = true;
    } else if (newm.TAMANO === "M") {
      this.tamMascota = 1;
      this.disableTam = true;
    } else if (newm.TAMANO === "L") {
      this.tamMascota = 2;
      this.disableTam = true;
    } else if (newm.TAMANO === "X") {
      this.tamMascota = 3;
      this.disableTam = true;
    } else if (typeof newm === undefined) {
      newm = '';
    }
  }

  private parseDate(date: any) {
    if (date !== '') {
      const arrDate = date.split('-');
      return arrDate.join('');
    }
    return '';
  }

  //Suma un año
  private sumYear(date: any) {
    if (date !== '') {
      const arrDate = date.split('-');
      arrDate[0] = parseInt(arrDate[0]) + 1;
      return arrDate.join('');
    }
    return '';
  }

  private consultaRazas(val: any) {
    this.visible = ''; // mostramos elementos
    this.data.raza = '';
    this.data.tamano = '';
    if (val === 1) {
      this.data.tipo = 'P';
    } else {
      this.data.tipo = 'G';
    }
    const razasM = this.$store.dispatch('getRazas', this.data);
    razasM.then((valor) => {
      this.razas = valor; // Arreglo para el select
    });
  }

  private consultaAlimentos(val: any) {
    let tipo = '';
    if (val === 1) {
      tipo = 'P';
    } else {
      tipo = 'G';
    }
    this.$store.dispatch('getAlimentos', tipo)
    .then((value) => {
      if (value.length > 0) {
        this.alimentos = value;
      }
    })
    .catch((error) => {
      
    });
  }

  // Change de tipo Mascota
  private selectPet(val: any) {
    if (val === 1) {//Perro
      this.img_dog = 'dog_colored.png';
      this.img_cat = 'cat.png';
    } else {//Gato
      this.img_cat = 'cat_colored.png';
      this.img_dog = 'dog.png';
    }
    this.tipoMasc = val;
    this.consultaRazas(this.tipoMasc);
    this.consultaAlimentos(this.tipoMasc);
  }

  private randomString(limit: number) {
    return Math.random().toString(36).substring(2, limit) + Math.random().toString(36).substring(2, limit);
  }

  // Click en imágenes de mascota
  private valorMascota() { this.consultaRazas(this.tipoMasc); }

  // Validación del formulario
  private validateForm() {
    // @ts-ignore
    this.$validator.validate()
    .then((result) => {
      if (result) {
        // Formulario a insertar en el web service
        this.formulario.idCliente = this.$store.getters.user;
        this.formulario.petName = this.nombre;
        this.formulario.idRaza = this.razaSeleccionada.IDRAZA;
        this.formulario.fechaNac = this.parseDate(this.cumpleanios);
        this.formulario.sexo = this.sexo;
        this.formulario.castrado = this.esterilizada;
        this.formulario.ultVacuna = this.parseDate(this.vacuna);
        this.formulario.ultVacunaExp = this.sumYear(this.vacuna);
        this.formulario.autPersona = this.personaAut;
        this.formulario.urlMascota = this.urlFoto;
        this.formulario.urlVacRabia = this.urlFotoR;
        this.formulario.urlVacMulti = this.urlFotoM;
        this.formulario.urlVacBorde = this.urlFotoB;
        this.formulario.alergia1 = this.alimentoSelected.TEXTO;
        const data2 = {
          idCliente: this.formulario.idCliente,
          idMascota: this.formulario.idMascota,
          petName: this.formulario.petName,
          idRaza: this.razaSeleccionada.IDRAZA,
          fechaNac: this.parseDate(this.cumpleanios),
          sexo: this.sexo,
          castrado: this.esterilizada,
          ultVacuna: this.parseDate(this.vacuna),
          ultVacunaExp: this.sumYear(this.vacuna),
          autPersona: this.personaAut,
          autPersTel: '',
          Peso: '',
          Color: '',
          SenaParticular: '',
          idGroomerPref: '',
          pielNormal: '',
          pielLlagas: '',
          perdidaPelo: '',
          pielSeca: '',
          pielPulgasGarr: '',
          artritis: '',
          ceguera: '',
          epilepsia: '',
          sordera: '',
          alergia1: this.alimentoSelected.TEXTO,
          alergia2: '',
          nomVeterinario: '',
          telVeterinario: '',
          fallecida: '',
          fechaFallecida: '',
          urlMascota: this.urlFoto,
          urlVacBorde: this.urlFotoB,
          urlVacRabia: this.urlFotoR,
          urlVacMulti: this.urlFotoM,
          imgMascota: '',
          imgVacBorde: '',
          imgVacRabia: '',
          imgVacMulti: ''
        }
        const respuesta = this.$store.dispatch('registraMascota', this.formulario);
        respuesta.then((resultado) => {
          if (resultado.replyCode === 201) { // Exito
            this.snackbar = true;
            this.type = 'success';
            this.text = 'Mascota Registrada';
            this.valid = true;
            this.visible = 'd-none';
            this.img_cat = 'cat.png';
            this.img_dog = 'dog.png';
            setTimeout(async () => {
              this.$router.push(await this.$store.dispatch('isDefined', this.$store.getters.idCallCenter) ? '/callCenter/mascotas' : '/mascotas');
            }, 1500);
          } else {
            this.snackbar = true;
            this.type = 'error';
            this.text = 'Hubo un error al registrar tu mascota, intenta más tarde';
            this.valid = false;
          }
        });
      } else {
        this.snackbar = true;
        this.type = 'error';
        this.text = 'Faltan campos por llenar';
        this.valid = false;
      }
    });
  }
}
